import { createAction } from '@reduxjs/toolkit';

export const setActiveOptionMenu = createAction<{ menuItem: string, catalogId: any }>(
  'SET_CURRENT_OPTIONS_MENU',
);

export default setActiveOptionMenu;
